"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import ChartIcon from "~/components/icons/chart-eon";
import DocumentListIcon from "~/components/icons/document-list-eon";
import GraduationCapIcon from "~/components/icons/graduation-cap-eon";
import GridIcon from "~/components/icons/grid-eon";
import NetworkIcon from "~/components/icons/network-eon";
import PeopleIcon from "~/components/icons/people-eon";
import type { JobadComponentProps } from "~/types/job";
export default function BenefitsEonGridsolutions(t0) {
  const $ = _c(5);
  const {
    job
  } = t0;
  const isTrainee = job?.data.entryLevel === "Werkstudierende / Praktikant:in";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="mb-8 font-bold text-4xl" data-source="text">Das zeichnet E.ON Grid Solutions als Arbeitgeber aus</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== isTrainee) {
    t2 = isTrainee ? benefitsTrainee.map(_temp) : benefits.map(_temp2);
    $[1] = isTrainee;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <section className="outer-container py-container print:hidden" id="benefits"><div className="inner-container grid gap-y-4">{t1}<ul className="grid grid-flow-row auto-rows-fr grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:gap-8">{t2}</ul></div></section>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp2(benefit_0) {
  return <li className="flex flex-col gap-y-4 break-words bg-primary p-8 text-white transition-all duration-200 hover:bg-primary-pressed md:gap-y-6" key={benefit_0.title}><div className="grid grid-flow-col items-center justify-start gap-x-4 gap-y-6 lg:grid-flow-row">{benefit_0.icon}<h3 className="font-bold text-2xl leading-6" data-source="text">{benefit_0.title}</h3></div><ul className="ml-4 list-disc text-base sm:text-lg [&>li]:mb-2" data-source="text">{benefit_0.text}</ul></li>;
}
function _temp(benefit) {
  return <li className="flex flex-col gap-y-4 break-words bg-[#0f738A] p-8 text-white transition-all hover:bg-[#2b91a3] md:gap-y-6" key={benefit.title}><div className="grid grid-flow-col items-center justify-start gap-x-4 gap-y-6 lg:grid-flow-row"><CustomImage alt={benefit.title} className="scale-150" height={48} src={`images/icons/eongrid/benefits/${benefit.icon}`} width={48} /><h3 className="font-bold text-2xl leading-6" data-source="text">{benefit.title}</h3></div><ul className="ml-4 list-disc text-base sm:text-lg [&>li]:mb-2" data-source="text">{benefit.text}</ul></li>;
}
const benefits = [{
  icon: <ChartIcon className="size-24" />,
  title: "Lern-Kultur",
  text: <>
        <li>
          Finanzielle und zeitliche Förderung sowie Angebot von
          berufsbegleitenden und persönlichen Fortbildungen
        </li>
        <li>Individuelle Weiterbildungsmöglichkeiten und Förderprogramme</li>
        <li>Digitale Lern- und Fortbildungsformate</li>
      </>
}, {
  icon: <GraduationCapIcon className="size-24" />,
  title: "Finanzielle Sicherheit",
  text: <>
        <li>Attraktive tarifliche Vergütung</li>
        <li>Weihnachtsgeld</li>
        <li>Erfolgsabhängige Vergütung</li>
        <li>Reisezeiten sind bei uns bezahlte Arbeitszeit</li>
        <li>Exklusive E.ON Mitarbeiterrabatte und -angebote</li>
      </>
}, {
  icon: <PeopleIcon className="size-24" />,
  title: "Work-Life-Balance",
  text: <>
        <li>37h Woche und 30 Tage Urlaub</li>
        <li>Familienservice</li>
        <li>Elternzeit für Mütter und Väter</li>
        <li>Teilzeit und Sabbaticals möglich</li>
        <li>
          E.ON Aktiv (Prävention Gesundheitsurlaub und Nutzung von
          Ferienwohnungen)
        </li>
      </>
}, {
  icon: <DocumentListIcon className="size-24" />,
  title: "Vorsorge",
  text: <>
        <li>Betriebliche Altersversorgung</li>
        <li>Vermögenswirksame Leistungen</li>
        <li>
          Weltweit gültige berufliche und private Gruppenunfallversicherung{" "}
        </li>
        <li>Gesundheitsaktionen, z.B. Grippeschutzimpfung</li>
      </>
}, {
  icon: <GridIcon className="size-20" />,
  style: "!scale-75",
  title: "Flexibilität",
  text: <>
        <li>Flexible Arbeitszeiten</li>
        <li>
          Kombination aus mobilem Arbeiten (Home-Office) und Vor-Ort-Präsenz
        </li>
        <li>Workation - bis zu 20 Tage p.a. aus dem Ausland arbeiten</li>
        <li>Zuschuss für den öffentlichen Nahverkehr</li>
        <li>Nutzung unseres Car- und Radleasingangebots</li>
      </>
}, {
  icon: <NetworkIcon className="size-28" />,
  title: "Wir-Gefühl",
  text: <>
        <li>Positive und inspirierende Arbeitsatmosphäre</li>
        <li>Vertrauen, Empowerment und Feedback wird bei uns geschätzt</li>
        <li>Modernes Arbeitsumfeld mit flachen Hierarchien</li>
        <li>Du-Kultur und ein Miteinander auf Augenhöhe</li>
        <li>Chancengleichheit und Vielfalt ist für uns ein Erfolgsfaktor</li>
      </>
}];
const benefitsTrainee = [{
  icon: <NetworkIcon />,
  title: "Wir-Gefühl",
  text: <>
        <li>positive und inspirierende Arbeitsatmosphäre</li>
        <li>modernes Arbeitsumfeld mit flachen Hierarchien</li>
        <li>agile Arbeitsmethoden und Raum für neue Ideen</li>
        <li>Du-Kultur und ein Miteinander auf Augenhöhe</li>
        <li>
          vielfältige Möglichkeiten zur Gestaltung unserer Unternehmenskultur
        </li>
      </>
}, {
  icon: <ChartIcon />,
  title: "Persönlich Entwicklung",
  text: <>
        <li>Förderung von eigenverantwortlichem Handeln</li>
        <li>
          breit gefächerte Möglichkeiten der persönlichen Weiterentwicklung
        </li>
        <li>
          attraktive Förderung von berufsbegleitenden und persönlichen
          Fortbildungen
        </li>
        <li>
          Chance, mit neuesten Technologie-Trends zu arbeiten und Innovationen
          voranzutreiben
        </li>
      </>
}, {
  icon: <PeopleIcon />,
  title: "Work-Life-Balance",
  text: <>
        <li>
          Flexible Arbeitszeiten, 20 Std./Woche (Vorlesungszeit) bis max. 37
          Std./Woche (Semesterferien) und 30 Tage Urlaub
        </li>
        <li>Attraktive Vergütung (16-18€/Std.)</li>
        <li>Kombination aus Home-Office und Vor-Ort-Präsenz</li>
        <li>
          zahlreiche interne Gesundheitsangebote, eine hochwertige Kantine mit
          vergünstigten Essenspreisen und Zugriff auf den Familienservice
        </li>
      </>
}];